import { langConfig } from '@/config'

const State = {
  currencyList: [],
  currencyJp: {},
  taxRateList: [],
  countryList: [],
  countryJp: {},
  countryCallingCodeList: [],
  countryCallingCodeJp: {},
  preferredStorageLocationList: [
    {
      id: 1,
      location:
        '〒144-0042 東京都大田区羽田旭町 10-11 MFIP羽田 3F 308 会社名：UNIONBOND LOGISTICS株式会社気付-JD外単備貨-株式会社アイディール TEL03-6423-6634'
    },
    {
      id: 2,
      location:
        '〒141-0022 東京都品川区東五反田1丁目7-6 藤和東五反田ビル4階 株式会社アイディール（TEL：03-5475-8945）'
    }
  ],
  customerCategoryList: [],
  customerCategoryMaxSortNumber: 0,
  productCategoryList: [],
  brandList: [],
  stockAdjustReasonList: [],
  oftenUseScreenList: [],
  hasDisplayedApiAlert: false,
  fxRateList: [],
  lang: langConfig.LANG_JA,
  ledgerSheetHeader: null,
  ledgerSheetData: null,
  isLoading: 0 // isLoading<=0の場合はfalse, isLoading>0の場合はtrue
}

export default State
